/** Javascript for base_external.html
*/

import './common/common';
import './common/search';

import './tracking/tracker';
import './tracking/doubleclick-display';
import './tracking/google-analytics';

import './iframe-resizer/iframeResizer.contentWindow';


/** Unload control

    When changing page, jump iframe container to top and show loading spinner
*/
window.onbeforeunload = function(event) {
    if ('parentIFrame' in window) {
        window.parentIFrame.scrollToOffset(0, 0);
        $('#external-content').hide();
        $('#external-loading').show();
    }
}


/** Tell parent that we're ready

    iframe-resizer normally just looks for onload, but that can take a while.
    Even if postgrad.com serves its images quickly, GA can sometimes hold
    things up - it loads async, but it still blocks the onload event.

    We therefore send a message to the parent that we're ready-ish and it
    should do an immediate resize by simulating an onload event.

    The real onload event will fire when the page is ready and catch any
    changes to the page height, but this will be close enough.
*/

if (window.parent) {
    window.parent.postMessage('domready', '*')
}
